import { Logo } from './logo'

interface LogoLoaderProps {
  /** What is on its way, under the mark — and what a screen reader announces. */
  label?: string
  className?: string
}

/**
 * The brand mark filling with colour, over a line naming what is on its way. A
 * report's wait: a long period can take a few seconds to read, and the mark says
 * the app is at work where a grey block only says something is missing.
 *
 * Two marks stacked: a grey one, and the brand one over it, revealed from the
 * bottom up — see `.logo-fill`.
 */
export function LogoLoader({ label = 'Loading…', className = '' }: LogoLoaderProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex flex-col items-center justify-center gap-3 ${className}`}
    >
      <div aria-hidden className="relative size-12">
        <Logo markOnly className="text-border absolute inset-0 size-full" />
        <Logo markOnly variant="brand" className="logo-fill absolute inset-0 size-full" />
      </div>
      <p className="text-muted text-sm">{label}</p>
    </div>
  )
}
